/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { ReCaptchaV3Model } from '../types/recaptcha.types';
import { typeDefaultForm } from '../configs/typeForms.config';

export const extendConfig = (
  config: ReCaptchaV3Model,
  modifyParams: any[]
): ReCaptchaV3Model | undefined => {
  if (config && config.forms) {
    const modifyForm = config.forms.concat(modifyParams).map((el) => {
      if (typeof el !== 'string') return { ...el, enabledBadgePlace: false };

      return {
        badgeId: typeDefaultForm[el],
        enabledBadgePlace: false,
      };
    });

    return { ...config, forms: [...new Set(modifyForm)] };
  }
};
